<div>
  <header class="navbar navbar-default container-fluid" id="navbar">
    <div class="container">
      <div class="navbar-header">
        <div class="region region-navigation">
          <a class="logo navbar-btn pull-left" routerLink="/" title="CDLSI 10th Anniversary Logo, home button." rel="home" *ngIf="translateService.currentLang==='en'">
            <img src="./assets/images/pics/CDLSI-Eng-Logo-Header.png" alt="Home">
          </a>
          <a class="logo navbar-btn pull-left" routerLink="/" title="Logo de 10e anniversaire de CDLSI, bouton d’accueil." rel="accueil" *ngIf="translateService.currentLang!='en'" style="margin-bottom: 20px;"> 
            <img src="./assets/images/pics/CDLSI-Fr-Logo-Header.png" alt="Accueil">
          </a>
        </div>

        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false" aria-controls="navbar-collapse">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>

      <div id="navbar-collapse" class="navbar-collapse collapse" aria-expanded="false">
        <div class="region region-navigation-collapsible">
          <section class="language-switcher-language-url block block-language block-language-blocklanguage-interface clearfix" id="block-languageswitcher" role="navigation">
            <ul class="links">
                <li hreflang="en" class="en is-active" aria-current="page" *ngIf="translateService.currentLang==='en'">
                  <a href="javascript:" class="language-link" lang="en" hreflang="en" (click)="changeLanguage('en')">English</a>
                </li>
                <li hreflang="en" class="en" *ngIf="translateService.currentLang!='en'">
                  <a href="javascript:" class="language-link" lang="en" hreflang="en" (click)="changeLanguage('en')">English</a>
                </li>
                <li hreflang="fr" class="fr is-active" aria-current="page" *ngIf="translateService.currentLang==='fr'">
                  <a href="javascript:" class="language-link" lang="fr" hreflang="fr" (click)="changeLanguage('fr')">Français</a>
                </li>
                <li hreflang="fr" class="fr" *ngIf="translateService.currentLang!='fr'">
                  <a href="javascript:" class="language-link" lang="fr" hreflang="fr" (click)="changeLanguage('fr')">Français</a>
                </li>
            </ul>
          </section>

          <nav class="footer-flex-item">
            <ul class="menu menu--main nav navbar-nav" data-toggle="collapse" data-target="#navbar-collapse"> 
              <li class="first">
                <a routerLink="/">{{ "HEADER_HOME" | translate }}</a>
              </li>
              <li class="menu-dropdown">
                <a>{{ "HEADER_REQUESTS" | translate }}</a>
                <ul class="menu-dropdown-content">
                  <li><a href="javascript:" (click)="handleRequestStatus()">{{ "HEADER_REQUESTS_STATUS" | translate }}</a></li>
                  <li><a href="javascript:" (click)="handleRequestList()">{{ "HEADER_REQUESTS_NEW_REQUEST" | translate }}</a></li>
                </ul>
              </li>
              <li>
                <a routerLink="/lessees-faq">{{ "HEADER_FAQ" | translate }}</a>
              </li>
              <!-- <li>
                <a routerLink="/join-the-cdlsi-team">{{ "HEADER_CAREERS" | translate }}</a>
              </li> -->
              <li>
                <a routerLink="/customer-intent">{{ "HEADER_CUSTOMER_INTENT" | translate }}</a>
              </li>
               <li>
                <a routerLink="/about-us">{{ "HEADER_ABOUTUS" | translate }}</a>
              </li>             
              <li class="last">
                <a routerLink="/contact-us">{{ "HEADER_CONTACT" | translate }}</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </header> 
</div>
